import { BaseService } from "./BaseService";

export class CitiesService extends BaseService {
  constructor() {
    super("cities");
  }
}